.container {
	display: flex;
	flex-direction: column;
}

.title {
	color: var(--ds-text-subtle, var(--jpo-text-secondary-color));
	font-size: 12px;
	font-weight: 600;
	margin-bottom: var(--jpo-common-base-spacing);
}
